import { ObjectManager } from '../../../concepts/objects';
import { EditorSession } from '../../canvas/EditorSession';
import { MyProfileInfo } from '../../canvas/MyProfileInfo';
import { QuickCreateInfo } from '../../canvas/tooling/QuickCreateInfo';
import { ActiveObject, resolve } from '../../Container';
import { Sticky } from './Sticky';

export class StickyMechanics extends ActiveObject {

    @resolve(ObjectManager) private objects!: ObjectManager;
    @resolve(EditorSession) private session!: EditorSession;

    public start(): void {
        const { session } = this;
        // Set QuickCreateInfo to be Sticky by default
        session.update(QuickCreateInfo, {
            type: Sticky,
        });

        this.burden(
            this.objects.createTrigger('Sticky.ClaimUnowned')
                .for(Sticky)
                .onChangesTo('content')
                .doForEach(this.claimUnownedSticky),
        );

    }

    private claimUnownedSticky = (sticky: Sticky) => {
        if (!sticky.userId) {
            sticky.userId = this.session.get(MyProfileInfo).id;
        }
    };

}
